import { IFormResult } from '@/interface';
/**
 * 解析form错误信息
 * @param result
 * @returns
 */
export const getFormErrorMsg = (result: IFormResult['result']) => {
  const errors = Object.keys(result)?.map(e => Array.from(new Set(result[e]?.map((m) => {
    const errorInfo = m?.errInfo?.filter(e => e?.message)?.[0]?.message;
    return m?.message || errorInfo;
  }))))
    .join('，');
  return errors;
};
